import {Api} from '@/core/api.js';
import Vue from 'vue';

const api = new Api();

// initial state
const state = {
  user: {},
  exp: -1,
  login: null,
  userLoadStatus: 0,
  list: []
}

// getters
const getters = {
    getSession( state ){
        return { user: state.user, exp: state.exp, login: state.login };
    },
    /*
        Returns the user load status.
    */
    getUserLoadStatus( state ){
        return function(){
            return state.userLoadStatus;
        }
    },

    getUser( state ) {
        return state.user;
    },

    getList: ( state ) => ( id ) => {
        // if( typeof id !== 'undefined' ) return state.list[ id ]

        // var aUsers = [ { id: null, name: "Sense asignar" } ];
        var aUsers = [];
        for( var i in state.list ){
            // if( state.list[ i ] ) aUsers.push( state.list[ i ] );
            if( state.list[ i ].visible ) aUsers.push( state.list[ i ] );
        }
        return aUsers;
    },

    getListNoFiltered: (state, getters, rootState) => () => {
      var aUsers = [];
      for( var i in state.list ){
          aUsers.push( state.list[ i ] );
      }
      return aUsers;
    },

    get_by_id: (state, getters, rootState) => ( id ) => {
        if( typeof state.list[ id ] !== 'undefined' ){
            var user = state.list[ id ]
            for( var k in user ){
                if( user[k] == 'true' ) user[k] = true
                else if( user[k] == 'false' ) user[k] = false
                else if( parseInt( user[k] ) == user[k] ) user[k] = parseInt( user[k] )
            }
    
            return user
        }
        return false;
    },

    getLanguage:( state, getters, rootState ) => {
        return state.user.language 
    }
}

const actions = {

    loadList({ commit }, params ) {

        var path = 'user';
        return api.get( path ).then( function( response ){
            if( response.status ){
                var data = response.data;
                var n = 0;
                for( var i in data ){
                    data[ i ].visible = true;
                }
                
                return commit('setList', data );
            }
        });
    },

    load_by_id( { commit }, params ) {
    var path = 'user/' + params.id ;
    return api.get( path ).then( function( response ){
        if( response.status ){
            var data = response.data;
            data.visible = true;
            
            return commit('addUser', data );
        }
    });
  },

  upload( context, data ){
    var user = {...data.data};
        user.event = data.event;
    console.log( user );
    var params = data.params;
    var path = ( typeof user.id !== 'undefined' )? 'user/' + user.id + '/update' : 'user/add';
    return api.post( path, user ).then( function( response ){
        if( response.status ){
            var data = response.data;
            data.visible = true;
            
            context.commit('addUser', data );
            return data.id;
        }
    });
  },

}
const mutations = {
    setAuthenticate ( state, data ) {
        //console.log("setAuthenticate");
        if( !data ){
            state = {
                user: {},
                exp: -1,
                login: null,
                userLoadStatus: 0
            }
        }   
        else{  
            data.user.avatar = '/img/user_w.svg';
            state.user = data.user;
            state.user.letter = data.user.name.substring(0,1).toUpperCase();
            state.exp = data.exp;
            state.login = moment();
            state.userLoadStatus = 2;
            state.user.token = data.token;

            // smartsupp('name', data.user.name );
            // smartsupp('email', data.user.email );
            // smartsupp('variables', data.user );

            // To set unique user id in your system when it is available
            // window.fcWidget.setExternalId( data.user.id );
            // // To set user name
            // window.fcWidget.user.setFirstName( data.user.name );
            // // To set user email
            // window.fcWidget.user.setEmail( data.user.email );
            // // To set user properties
            // window.fcWidget.user.setProperties( data.user );
        }
        return true;
    },

    logoutUser( state ){
        state = {
            user: {},
            exp: -1,
            login: null,
            userLoadStatus: 0
        }

        localStorage.removeItem( 'token' );
    },

    setList (state, data) {
        state.list = data;
    },

    addUser ( state, user ) {
        var list = { ...state.list };
        list[ user.id ] = user;

        state.list = list;
    },

    applyFilters( state, filters ) {
        var list = {...state.list};
        if( !filters ){
            for( var i in list ){
                list[ i ].visible = true;
            }
        }
        else {
            for( var i in list ){
                list[ i ].visible = false;
            }
            for( var i in list ){
                var item = list[ i ];
                var bFound = true;
                for( var k in filters ){
                    // console.log( "--- KEY: " + k + " ---" )
                    // var item_value = ( item[k] != null && typeof item[k] == 'object' )? item[k].id : item[k];
                    // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] );
                    // var regexp = new RegExp( filters[k].trim(), "gi" );
                    // if( item.hasOwnProperty( k ) && typeof item[k] == 'object' && filters[ k ] != item_value ) {
                    //   bFound = false;
                    // }
                    // else if( item.hasOwnProperty( k ) && typeof item[k] !== 'object' && !item_value.match( regexp ) ){
                    //     bFound = false;
                    // }
                    if( filters[k] != -1 ){
                        var item_value = ( item[k] != null && typeof item[k] == 'object' )? item[k].id : item[k];
                        if( item.hasOwnProperty( k ) && filters[k] == null && item_value == null ){

                        }
                        else{
                            // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
                            // filters[k] = filters[k] == null ? null : ( typeof filters[k] !== 'string' ? ( typeof filters[k] !== 'boolean' ? ( filters[k] ? 1 : 0 ) : filters[k] ) : filters[k].trim() ) 
                            
                            if( filters[k] != null && typeof filters[k] === 'boolean' ) filters[k] = filters[k] ? 1 : 0
                            else if( filters[k] != null && typeof filters[k] === 'string' ) filters[k] = filters[k].trim()
                            
                            // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
                            var regexp = new RegExp( filters[k], "gi" );
                            
                            if( item.hasOwnProperty( k ) && typeof item[k] == 'object' && filters[ k ] != item_value ) {
                            bFound = false;
                            }
                            else if( item.hasOwnProperty( k ) && typeof item[k] !== 'object' && !item_value.match( regexp ) ){
                                bFound = false;
                            }
                        }
                    }
                }

                list[ i ].visible = bFound;
                
            }
        }

        state.list = list;
    },

    setLanguage(state, value){
        state.user.language = value;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }